import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { BaseURL } from "../../constants/enum/baseURL.emum";
import { curriContext } from "../../pages/summary/summary";
import sumService from "../../services/sum.service";
import ShowDoc from "../common/showDoc";
import BtnSendFile from "./btnSendFile";

const Senditem = (props: {
  form: { type: string; year: string; term: string };
  curri: {
    id: number;
    level: string;
    degreeName: string;
    name: string;
    shortName: string;
  };
  typeDocTH: string;
}) => {
  const { reCheck, setReCheck } = useContext<any>(curriContext);
  const { curri, form, typeDocTH } = props;
  const [send, setSend] = useState(false);
  const me = useSelector((state: any) => state.me);
  const [item, setItem] = useState<{
    pathFile: string;
    report: string;
    id: number;
  }>({
    pathFile: "",
    report: "",
    id: 0,
  });

  useEffect(() => {
    (async () => {
      await sumService
        .getdata({
          type: form.type,
          year: Number(form.year),
          term: Number(form.term),
          curriculum: curri.id,
        })
        .then((res) => {
          if (res.data) {
            setItem({
              pathFile: res.data.pathFile,
              report: res.data.report,
              id: res.data.id,
            });
            setSend(true);
          }
          setReCheck(false);
        });
    })();
  }, [curri.id, form.term, form.type, form.year, reCheck, setReCheck]);

  const onDelete = async () => {
    Swal.fire({
      title: "คุณต้องการลบ?",
      text: `แบบสรุป ${typeDocTH} หลักสูตร ${curri.name} ประจำภาค ${
        form.term
      }/${form.year.substring(2)}!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ใช่, ลบเลย!",
      cancelButtonText: "ยกเลิก!",
    }).then((result) => {
      if (result.isConfirmed) {
        sumService.onDelete(item.id).then(() => {
          Swal.fire(
            "ลบข้อมูลสำเร็จ!",
            `ลบแบบสรุป ${typeDocTH} หลักสูตร ${curri.name} ประจำภาค ${
              form.term
            }/${form.year.substring(2)}เรียบร้อย`,
            "success"
          );
          setSend(false);
        });
      }
    });
  };

  //////// ตรงนี้จะมี่ return สอง แบบ คือแบบที่ส่งแล้ว และแบบที่ยังไม่ส่ง
  if (send) {
    return (
      <tr>
        <td style={{ width: "60%" }} className="text-start">
          {curri.name}
        </td>
        <td>{moment(item.report).add(543, "year").format("DD/MM/yyyy")}</td>
        <td style={{ width: "20%" }}>
          <ShowDoc
            btnName={typeDocTH}
            url={`${BaseURL.BASE_URL}/upload/summary/${form.type}/${item.pathFile}`}
          />

          {me.role === "Admin" && (
            <button className="ms-1 btn btn-danger btn-sm" onClick={onDelete}>
              ลบ
            </button>
          )}
        </td>
      </tr>
    );
  }

  return (
    <tr>
      <td style={{ width: "60%" }} className="text-start">
        {curri.name}
      </td>
      <td></td>
      <td style={{ width: "20%" }}>
        {me.role === "Admin" && (
          <BtnSendFile form={form} curri={curri} typeDocTH={typeDocTH} />
        )}
      </td>
    </tr>
  );
};

export default Senditem;
